<template>
  <v-btn
    id="searchButton"
    dark
    depressed
    :style="getCustomButtonStyle"
    @click="searchProperties"
  >
    Go
  </v-btn>
</template>

<script>
import { mapState } from 'vuex'
import searchLayoutHandler from '../../mixins/searchLayoutHandler'

export default {
  mixins: [searchLayoutHandler],

  computed: {
    ...mapState('common', ['searchObject']),

    getCustomButtonStyle() {
      return {
        height: this.searchObject.searchResult ? '40px' : '60px',
        'border-radius': this.searchObject.searchResult ? '3px' : '0px'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#searchButton
  margin: 0 !important
  width: 100%
  font-size: 1.6rem
  text-transform: capitalize
  background-color: $hwayzBrandBlue
</style>
